import dayjs from "dayjs";
import { capitalize } from "lodash";

import { useModuleName } from "./useModuleName";

/**
 * @param prefix Optional prefix for the filename (defaults to "GrowthOS")
 * @param dateFormat Optional date format (defaults to "MMMM D")
 * @returns Object containing the generated filename and its components
 */
export const useFileName = (prefix = "GrowthOS", dateFormat = "MMMM D") => {
  const { moduleName, pathname } = useModuleName();
  const formattedDate = dayjs().format(dateFormat);
  const fileName = `${prefix} ${capitalize(moduleName)} ${formattedDate}`;

  return {
    fileName,
    module: capitalize(moduleName),
    formattedDate,
    pathname,
  };
};

export default useFileName;
